import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

const PageSettingsContext = createContext({});

export function PageSettingsProvider({ children }) {
  const [pages, setPages] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from('page_settings')
      .select('*')
      .then(({ data }) => {
        if (data) {
          const map = {};
          data.forEach(p => { map[p.id] = p.enabled; });
          setPages(map);
        }
      })
      .catch(() => {
        // If page settings fail to load, default all pages to enabled
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const isEnabled = (pageId) => pages[pageId] !== false;

  return (
    <PageSettingsContext.Provider value={{ pages, setPages, isEnabled, loading }}>
      {children}
    </PageSettingsContext.Provider>
  );
}

export const usePageSettings = () => useContext(PageSettingsContext);
